<template>
  <div>
    <PasswordResetPopup
      :show="showPasswordReset"
      :token="resetPasswordToken"
    ></PasswordResetPopup>

    <Header></Header>

    <CardsListAll
      :title="'Все методы'"
    ></CardsListAll>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import CardsListAll from "@/components/CardsListAll.vue";
import PasswordResetPopup from "@/components/PasswordResetPopup.vue";
import store from "@/store";
import { mapGetters } from 'vuex';

export default {
  components: {
    Header, CardsListAll, PasswordResetPopup
  },
  props: {
    showPasswordReset: { type: Boolean, default: function() { return false; } },
    resetPasswordToken: { type: String, default: function() { return null; } },
  }
};
</script>

<style>
.Lib{
  position: relative;
  margin: 15px auto 50px;
  min-width: 1300px;
  width: 85%;
  text-align: center;
  /* height: 2800px; */
    /* display: block; */
    /* clear: both; */

}

.SiteName2{
  margin: 0px auto;
  padding-top: 10px;
  width: 1000px;
  height: 70px;
  border: 0px solid #ccc;
  font-family: 'Fira Sans Condensed', sans-serif;
  font-size: 46px;
  line-height: 0.9;
  color: #37bbd6;
  /* font-weight: normal;
  background-image: url("../assets/img/logo-em-small.png");
  background-position: right top;
  background-repeat: no-repeat; */
}

.SitePodpis2{
  margin: 0px auto;
  padding-top: 15px;
  width: 1000px;
  height: 30px;
  border: 0px solid #ccc;
  font-family: 'Caveat', cursive;
  font-size: 20px;
  line-height: 1;
  color: #000000;
  /* font-weight: normal; */
}


/*.MMarkers{
  margin-left: 48px;
  margin-top: 30px;
}
*/

/* .MMName{
  margin-left: 60px;
  margin-top: 70px;
  font-family: 'Fira Sans Condensed', sans-serif;
  color: #000;
  font-weight: bold;
  font-size: 36px;

} */


/* .MVName{
  margin-left: 60px;
  margin-top: 0px;
  font-family: 'Fira Sans Condensed', sans-serif;
  color: #000;
  font-weight: nodmal;
  font-size: 22px;
} */



</style>
